export const admin = {
  layout: {
    home: 'الرئيسية',
  },
  
  sidebar: {
    dashboard: 'لوحة التحكم',
    agencies: 'الوكالات',
    cars: 'السيارات',
    clients: 'العملاء',
    bookings: 'الحجوزات',
    factures: 'الفواتير',
    stats: 'الإحصائيات',
    users: 'المستخدمون',
    vehicles: 'المركبات',
    payments: 'المدفوعات',
    reports: 'التقارير',
    documents: 'المستندات',
    security: 'الأمان',
    settings: 'الإعدادات',
    help: 'المساعدة والدعم',
    brandsModels: 'العلامات التجارية والموديلات',
  },
  
  // Dashboard
  title: 'لوحة تحكم الإدارة',
  subtitle: 'إدارة منصة كيراكار الخاصة بك',
  
  // Overview
  totalUsers: 'إجمالي المستخدمين',
  totalVehicles: 'إجمالي المركبات',
  monthlyRevenue: 'الإيرادات الشهرية',
  platformActivity: 'نشاط المنصة',
  
  // Dashboard Cards (Root level for component access)
  totalAgencies: 'إجمالي الوكالات',
  active: 'نشطة',
  totalCars: 'إجمالي السيارات',
  acrossAllAgencies: 'في جميع الوكالات',
  totalRevenue: 'إجمالي الإيرادات',
  allTimeRevenue: 'إيرادات جميع الأوقات',
  selected: 'محدد',
  searchAgencies: 'البحث في الوكالات',
  columns: 'الأعمدة',
  showingAgencies: 'عرض {{count}} من {{total}} وكالة',
  allCities: 'جميع المدن',
  filters: 'المرشحات',
  
  // Cars Admin Page Keys
  totalBookings: 'إجمالي الحجوزات',
  acrossAllCars: 'في جميع السيارات',
  available: 'متاحة',
  allAgencies: 'جميع الوكالات',
  allCategories: 'جميع الفئات',
  searchCars: 'البحث في السيارات',
  
  // Additional Agency Admin Keys
  allAgencyLocations: 'جميع مواقع الوكالة',
  allReviewsAndRatings: 'جميع المراجعات والتقييمات',
  allNotifications: 'جميع الإشعارات',
  
  // Agency Deletion Dialog Keys
  cancel: 'إلغاء',
  yesDeleteEverything: 'نعم، احذف كل شيء',
  
  // Clients Admin Page Keys
  verifiedClients: 'العملاء المتحققون',
  totalClients: 'إجمالي العملاء',
  searchClients: 'البحث في العملاء',
  showingClients: 'عرض {{count}} من {{total}} عميل',
  allVerification: 'جميع التحققات',
  fromAllClients: 'من جميع العملاء',
  
  // Users
  userManagement: 'إدارة المستخدمين',
  agencyOwners: 'أصحاب الوكالات',
  administrators: 'المديرون',
  
  // Common actions
  view: 'عرض',
  edit: 'تعديل',
  delete: 'حذف',
  approve: 'موافقة',
  reject: 'رفض',
  activate: 'تفعيل',
  deactivate: 'إلغاء التفعيل',
  
  // Common buttons
  export: 'تصدير',
  download: 'تحميل',
  save: 'حفظ',
  saveChanges: 'حفظ التغييرات',
  close: 'إغلاق',
  changePassword: 'تغيير كلمة المرور',
  mustBeLoggedIn: 'يجب أن تكون مسجلاً الدخول لتنفيذ هذا الإجراء.',
  cancelSelected: 'إلغاء المحدد',
  refresh: 'تحديث',
  markCompleted: 'وضع علامة كمكتمل',
  sendSelected: 'إرسال المحدد',
  markAsPaid: 'وضع علامة كمدفوع',
  viewInvoice: 'عرض الفاتورة',
  sendToCustomer: 'إرسال للعميل',
  editInvoice: 'تعديل الفاتورة',
  editAgency: 'تعديل الوكالة',
  editClient: 'تعديل العميل',
  editBooking: 'تعديل الحجز',
  deleteCar: 'حذف السيارة',
  deleteBooking: 'حذف الحجز',
  addAgency: 'إضافة وكالة',
  addCar: 'إضافة سيارة',
  addBooking: 'إضافة حجز',
  addClient: 'إضافة عميل',
  createInvoice: 'إنشاء فاتورة',
  create: 'إنشاء',
  actions: 'الإجراءات',
  areYouSure: 'هل أنت متأكد',
  actionCannotBeUndone: 'لا يمكن التراجع عن هذا الإجراء',
  willPermanentlyDelete: 'سيؤدي هذا إلى حذف نهائي',
  areYouAbsolutelySure: 'هل أنت متأكد تماماً؟',
  deleteClient: 'حذف العميل',
  andAllOf: 'وجميع',
  andAllOfTheir: 'وجميع',
  associatedData: 'البيانات المرتبطة',
  for: 'لـ',
  manageAndTrack: 'إدارة ومتابعة جميع الفواتير والمدفوعات',
  editingDetailsFor: 'تعديل التفاصيل لـ',
  viewingDetailsFor: 'عرض التفاصيل لـ',
  editingBookingFor: 'تعديل الحجز لـ',
  viewingBookingDetailsFor: 'عرض تفاصيل الحجز لـ',
  theFollowingWillBeDeleted: 'سيتم حذف ما يلي:',
  bookingFor: 'حجز لـ',
  hasBeenPermanentlyDeleted: 'تم حذفه نهائياً',
  invoice: 'فاتورة',
  bookingId: 'رقم الحجز',
  customer: 'العميل',
  email: 'البريد الإلكتروني',
  vehicle: 'المركبة',
  startDate: 'تاريخ البداية',
  endDate: 'تاريخ النهاية',
  duration: 'المدة',
  totalAmount: 'المبلغ الإجمالي',
  days: 'أيام',
  emailSelected: 'البريد الإلكتروني المحدد',
  avgDuration: 'المدة المتوسطة',
  fullName: 'الاسم الكامل',
  phone: 'الهاتف',
  username: 'اسم المستخدم',
  averageRentalPeriod: 'فترة الإيجار المتوسطة',
  blockSelected: 'حظر المحدد',
  deleteSelected: 'حذف المحدد',
  amount: 'المبلغ',
  paymentStatus: 'حالة الدفع',
  generated: 'تم إنشاؤه',
  role: 'الدور',
  agencyName: 'اسم الوكالة',
  country: 'البلد',
  address: 'العنوان',
  description: 'الوصف',
  notes: 'الملاحظات',
  durationDays: 'المدة (أيام)',
  addNotesPlaceholder: 'إضافة ملاحظات حول هذا الحجز...',
  noDescriptionProvided: 'لم يتم توفير وصف.',
  generatingInvoice: 'جاري إنشاء الفاتورة...',
  unknownCustomer: 'عميل غير معروف',
  notAvailable: 'غير متوفر',
  allStatus: 'جميع الحالات',
  noEmail: 'لا يوجد بريد إلكتروني',
  unknownAgency: 'وكالة غير معروفة',
  bookingsByStatus: 'الحجوزات حسب الحالة',

  dashboard: {
    title: 'لوحة تحكم الإدارة',
    overview: 'نظرة عامة',
    customers: 'العملاء',
    agencies: 'الوكالات',
    vehicles: 'المركبات',
    analytics: 'التحليلات',
    recentActivity: 'النشاط الأخير',
    quickActions: 'الإجراءات السريعة',
    newAgencyRegistered: 'وكالة جديدة مسجلة',
    agencyJoinedPlatform: 'انضمت وكالة جديدة إلى المنصة',
    vehicleAdded: 'تم إضافة مركبة',
    vehicleAddedToInventory: 'تم إضافة مركبة جديدة إلى المخزون',
    bookingCompleted: 'تم إكمال الحجز',
    customerCompletedRental: 'أكمل العميل الإيجار',
    userVerification: 'التحقق من المستخدم',
    newUserVerified: 'تم التحقق من حساب مستخدم جديد',
    hoursAgo: 'منذ {{count}} ساعات',
    manageCustomers: 'إدارة العملاء',
    manageAgencies: 'إدارة الوكالات',
    manageVehicles: 'إدارة المركبات',
    viewAnalytics: 'عرض التحليلات',
    agencyManagement: 'إدارة الوكالات',
    agencyManagementDesc: 'إدارة ومراقبة جميع وكالات التأجير على المنصة',
    addNewAgency: 'إضافة وكالة جديدة',
    vehicleManagement: 'إدارة المركبات',
    vehicleManagementDesc: 'إدارة ومراقبة جميع المركبات عبر الوكالات',
    addNewVehicle: 'إضافة مركبة جديدة',
    
    // Dashboard Cards
    totalUsers: 'إجمالي المستخدمين',
    registeredUsers: 'المستخدمون المسجلون على المنصة',
    totalAgencies: 'إجمالي الوكالات',
    active: 'نشطة',
    activeAgencies: 'وكالات التأجير النشطة',
    totalCars: 'إجمالي السيارات',
    acrossAllAgencies: 'في جميع الوكالات',
    totalVehicles: 'إجمالي المركبات',
    availableVehicles: 'المركبات المتاحة',
    totalRevenue: 'إجمالي الإيرادات',
    allTimeRevenue: 'إيرادات جميع الأوقات',
    completedBookings: 'من الحجوزات المكتملة',
    selected: 'محدد',
    ofSelected: 'من {{total}} محدد',
    totalBookings: 'إجمالي الحجوزات',
    allTimeBookings: 'حجوزات جميع الأوقات',
    activeBookings: 'الحجوزات النشطة',
    currentlyActive: 'نشطة حالياً',
    pendingBookings: 'الحجوزات المعلقة',
    awaitingConfirmation: 'في انتظار التأكيد',
    totalLocations: 'إجمالي المواقع',
    agencyLocations: 'مواقع الوكالات',
    fromLastMonth: 'من الشهر الماضي',
    statsError: 'خطأ في تحميل الإحصائيات'
  },
  
  analytics: {
    errorTitle: 'خطأ في التحليلات',
    retry: 'إعادة المحاولة',
    topAgency: 'أفضل وكالة',
    byRevenue: 'حسب الإيرادات',
    topCategory: 'أفضل فئة',
    mostPopular: 'الأكثر شعبية',
    avgBookingValue: 'متوسط قيمة الحجز',
    perBooking: 'لكل حجز',
    conversionRate: 'معدل التحويل',
    visitorsToBookings: 'الزوار إلى الحجوزات',
    agencyPerformance: 'أداء الوكالات',
    vehicles: 'المركبات',
    bookings: 'الحجوزات',
    revenue: 'الإيرادات',
    rating: 'التقييم',
    completion: 'الإكمال',
    categoryDistribution: 'توزيع الفئات'
  },
  
  agencies: {
    title: 'إدارة الوكالات',
    subtitle: 'إدارة ومراقبة جميع وكالات التأجير',
    all: 'الكل',
    active: 'نشطة',
    pending: 'معلقة',
    suspended: 'معلقة',
    searchAgencies: 'البحث في الوكالات',
    allStatus: 'جميع الحالات',
    allCities: 'جميع المدن',
    filters: 'المرشحات',
    columns: 'الأعمدة',
    showingAgencies: 'عرض {{count}} من {{total}} وكالة',
    errorTitle: 'فشل في تحميل الوكالات',
    retry: 'إعادة المحاولة',
    website: 'الموقع الإلكتروني',
    vehicles: 'المركبات',
    bookings: 'الحجوزات',
    revenue: 'الإيرادات',
    rating: 'التقييم',
    completion: 'الإكمال',
    lastActivity: 'آخر نشاط',
    joinedOn: 'انضم في',
    locations: 'المواقع',
    more: 'أكثر',
    noAgencies: 'لم يتم العثور على وكالات',
    noAgenciesDesc: 'لا توجد وكالات تطابق المرشحات الحالية',
    yesterday: 'أمس',
    daysAgo: 'منذ {{count}} أيام',
    weeksAgo: 'منذ {{count}} أسابيع',
    monthsAgo: 'منذ {{count}} أشهر',
    
    // Table columns
    name: 'اسم الوكالة',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    city: 'المدينة',
    country: 'البلد',
    cars: 'السيارات',
    status: 'الحالة',
    username: 'اسم المستخدم',
    address: 'العنوان',
    
    // Filters
    
    // Actions
    view: 'عرض',
    edit: 'تعديل',
    delete: 'حذف',
    actions: 'الإجراءات',
    
    // Dialog
    agencyDetails: 'تفاصيل الوكالة',
    editAgency: 'تعديل الوكالة',
    noUsername: 'لا يوجد اسم مستخدم',
    
    // Messages
    fetchError: 'فشل في تحميل الوكالات',
    deleteError: 'فشل في حذف الوكالة',
    deleteSuccess: 'تم حذف الوكالة بنجاح',
    updateSuccess: 'تم تحديث الوكالة بنجاح',
    updateError: 'فشل في تحديث الوكالة',
    deleteFailed: 'فشل في حذف الوكالة',
    permissionDenied: 'تم رفض الإذن. قد لا تملك الصلاحيات اللازمة لحذف هذه الوكالة.',
    
    // Common placeholders
    min: 'الحد الأدنى',
    max: 'الحد الأقصى',
    
    // Password management
    newPassword: 'كلمة المرور الجديدة',
    enterNewPassword: 'أدخل كلمة مرور جديدة (حد أدنى 6 أحرف)',
    passwordHint: 'اتركه فارغًا للاحتفاظ بكلمة المرور الحالية. الحد الأدنى 6 أحرف.',
    generatePassword: 'إنشاء كلمة مرور عشوائية',
    sendPasswordEmail: 'إرسال كلمة المرور إلى البريد الإلكتروني',
    passwordRequired: 'يرجى إنشاء أو إدخال كلمة مرور أولاً.',
    passwordTooShort: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل.',
    ownerNotFound: 'تعذر العثور على مالك الوكالة.',
    ownerEmailNotFound: 'تعذر العثور على عنوان بريد مالك الوكالة.',
    emailSendFailed: 'فشل إرسال البريد الإلكتروني',
    passwordEmailSent: 'تم إرسال كلمة المرور إلى بريد مالك الوكالة.',
    emailSendError: 'فشل إرسال البريد الإلكتروني بكلمة المرور. يرجى المحاولة مرة أخرى.'
  },
  
  vehicles: {
    title: 'إدارة المركبات',
    subtitle: 'إدارة ومراقبة جميع المركبات عبر الوكالات',
    totalVehicles: 'إجمالي المركبات',
    acrossAllAgencies: 'عبر جميع الوكالات',
    averagePrice: 'متوسط السعر',
    perDay: 'لليوم',
    utilization: 'معدل الاستخدام',
    averageUtilization: 'متوسط الاستخدام',
    topCategory: 'أفضل فئة',
    mostPopular: 'الأكثر شعبية',
    allCategories: 'جميع الفئات',
    all: 'الكل',
    available: 'متاحة',
    rented: 'مؤجرة',
    maintenance: 'صيانة',
    unavailable: 'غير متاحة',
    errorTitle: 'فشل في تحميل المركبات',
    retry: 'إعادة المحاولة',
    seats: 'مقاعد',
    bookings: 'الحجوزات',
    revenue: 'الإيرادات',
    rating: 'التقييم',
    lastBooked: 'آخر حجز',
    noVehicles: 'لم يتم العثور على مركبات',
    noVehiclesDesc: 'لا توجد مركبات تطابق المرشحات الحالية',
    yesterday: 'أمس',
    daysAgo: 'منذ {{count}} أيام',
    weeksAgo: 'منذ {{count}} أسابيع',
    monthsAgo: 'منذ {{count}} أشهر'
  },

  cars: {
    title: 'السيارات',
    subtitle: 'إدارة ومراقبة جميع السيارات عبر الوكالات',
    totalCars: 'إجمالي السيارات',
    acrossAllAgencies: 'عبر جميع الوكالات',
    averagePrice: 'متوسط السعر',
    perDay: 'لليوم',
    utilization: 'معدل الاستخدام',
    averageUtilization: 'متوسط الاستخدام',
    topCategory: 'أفضل فئة',
    mostPopular: 'الأكثر شعبية',
    allCategories: 'جميع الفئات',
    all: 'الكل',
    errorTitle: 'فشل في تحميل السيارات',
    retry: 'إعادة المحاولة',
    bookings: 'الحجوزات',
    revenue: 'الإيرادات',
    rating: 'التقييم',
    lastBooked: 'آخر حجز',
    noCars: 'لم يتم العثور على سيارات',
    noCarsDesc: 'لا توجد سيارات تطابق المرشحات الحالية',
    yesterday: 'أمس',
    daysAgo: 'منذ {{count}} أيام',
    weeksAgo: 'منذ {{count}} أسابيع',
    monthsAgo: 'منذ {{count}} أشهر',
    
    // Table columns
    make: 'العلامة التجارية',
    model: 'الموديل',
    year: 'السنة',
    color: 'اللون',
    category: 'الفئة',
    transmission: 'ناقل الحركة',
    fuelType: 'نوع الوقود',
    seats: 'المقاعد',
    pricePerDay: 'السعر/اليوم',
    availability: 'متاحة',
    agency: 'الوكالة',
    bookingCount: 'الحجوزات',
    created: 'تم الإنشاء',
    
    // Filters
    status: 'الحالة',
    
    // Status labels
    available: 'متاحة',
    rented: 'مؤجرة',
    maintenance: 'صيانة',
    unavailable: 'غير متاحة',
    
    // Actions
    view: 'عرض',
    edit: 'تعديل',
    delete: 'حذف',
    actions: 'الإجراءات',
    
    // Dialog
    carDetails: 'تفاصيل السيارة',
    editCar: 'تعديل السيارة',
    viewCarInfo: 'عرض المعلومات التفصيلية لهذه السيارة',
    editCarInfo: 'تعديل معلومات السيارة',
    description: 'الوصف',
    noDescription: 'لا يوجد وصف',
    selectTransmission: 'اختر ناقل الحركة',
    selectAvailability: 'اختر التوفر',
    close: 'إغلاق',
    cancel: 'إلغاء',
    save: 'حفظ',
    deleting: 'جاري الحذف...',
    deleteCar: 'حذف السيارة',
    
    // Messages
    fetchError: 'فشل في تحميل السيارات',
    deleteError: 'لا يمكن حذف سيارة لها حجوزات نشطة',
    deleteSuccess: 'تم حذف السيارة بنجاح',
    updateSuccess: 'تم تحديث السيارة بنجاح',
    updateError: 'فشل في تحديث السيارة',
    deleteFailed: 'فشل في حذف السيارة',
    
    // CSV Export
    csvHeaders: ['العلامة التجارية', 'الموديل', 'السنة', 'اللون', 'الفئة', 'ناقل الحركة', 'نوع الوقود', 'المقاعد', 'السعر/اليوم', 'الوكالة', 'الحجوزات', 'الإيرادات', 'الحالة', 'تم الإنشاء']
  },
  
  customers: {
    title: 'إدارة العملاء',
    subtitle: 'إدارة ومراقبة جميع العملاء',
    totalCustomers: 'إجمالي العملاء',
    activeCustomers: 'العملاء النشطون',
    verifiedCustomers: 'العملاء المتحققون',
    newThisMonth: 'جديد هذا الشهر',
    errorTitle: 'فشل في تحميل العملاء',
    retry: 'إعادة المحاولة'
  },

  bookings: {
    title: 'الحجوزات',
    subtitle: 'إدارة ومراقبة جميع الحجوزات',
    totalBookings: 'إجمالي الحجوزات',
    activeBookings: 'الحجوزات النشطة',
    completedBookings: 'الحجوزات المكتملة',
    cancelledBookings: 'الحجوزات الملغاة',
    errorTitle: 'فشل في تحميل الحجوزات',
    retry: 'إعادة المحاولة',
    
    // Table columns
    bookingId: 'رقم الحجز',
    customer: 'العميل',
    agency: 'الوكالة',
    carMake: 'ماركة السيارة',
    carModel: 'موديل السيارة',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    duration: 'المدة',
    amount: 'المبلغ',
    status: 'الحالة',
    payment: 'الدفع',
    created: 'تم الإنشاء',
    customerEmail: 'بريد العميل',
    pickupLocation: 'مكان الاستلام',
    returnLocation: 'مكان الإرجاع',
    
    // Filters
    
    // Status labels
    pending: 'معلق',
    confirmed: 'مؤكد',
    active: 'نشط',
    completed: 'مكتمل',
    cancelled: 'ملغي',
    
    // Payment status
    paid: 'مدفوع',
    failed: 'فشل',
    refunded: 'مسترد',
    
    // Actions
    view: 'عرض',
    edit: 'تعديل',
    delete: 'حذف',
    actions: 'الإجراءات',
    downloadInvoice: 'تحميل الفاتورة',
    markCompleted: 'تحديد كمكتمل',
    cancel: 'إلغاء',
    resendWhatsApp: 'إعادة إرسال واتساب',
    
    // Resend WhatsApp dialog
    resendWhatsAppTitle: 'إعادة إرسال إشعار واتساب',
    resendWhatsAppDescription: 'عدّل متغيرات القالب أدناه وأرسل إشعار الحجز الجديد لمالك الوكالة.',
    resendWhatsAppBooking: 'الحجز',
    resendWhatsAppSend: 'إرسال واتساب',
    whatsappVarId: 'المعرف',
    whatsappVarClient: 'العميل',
    whatsappVarCarMake: 'ماركة السيارة',
    whatsappVarCarModel: 'موديل السيارة',
    whatsappVarDepart: 'تاريخ البداية',
    whatsappVarRetour: 'تاريخ النهاية',
    whatsappVarPrix: 'السعر الإجمالي',
    whatsappVarTele: 'الهاتف',
    
    // Dialog
    bookingDetails: 'تفاصيل الحجز',
    editBooking: 'تعديل الحجز',
    selectStatus: 'اختر الحالة',
    selectPaymentStatus: 'اختر حالة الدفع',
    
    // Messages
    fetchError: 'فشل في تحميل الحجوزات',
    deleteError: 'فشل في حذف الحجز',
    deleteSuccess: 'تم حذف الحجز بنجاح',
    updateSuccess: 'تم تحديث الحجز بنجاح',
    updateError: 'فشل في تحديث الحجز',
    deleteFailed: 'فشل في حذف الحجز',
    permissionDenied: 'تم رفض الإذن. قد لا تملك الصلاحيات اللازمة لحذف هذا الحجز.',
    bookingDataNotFound: 'بيانات الحجز غير موجودة',
    invoiceDownloaded: 'تم تحميل الفاتورة بنجاح',
    bookingCompleted: 'تم تحديد الحجز كمكتمل',
    bookingCancelled: 'تم إلغاء الحجز',
    whatsappNotificationFailed: 'تم إنشاء الحجز لكن فشل إرسال واتساب',
    whatsappResendSuccess: 'تم إرسال إشعار واتساب بنجاح',
    
    // Placeholders
    noCustomer: 'لا يوجد عميل',
    noEmail: 'لا يوجد بريد إلكتروني',
    unknownAgency: 'وكالة غير معروفة',
    unknown: 'غير معروف',
    notSpecified: 'غير محدد',
    
    // Common placeholders
    min: 'الحد الأدنى',
    max: 'الحد الأقصى',
    
    // Booking creation dialog
    createBooking: 'إنشاء حجز',
    createBookingDescription: 'إنشاء حجز جديد لأي وكالة',
    selectAgency: 'اختر الوكالة',
    selectCustomer: 'اختر العميل',
    selectCar: 'اختر السيارة',
    agencyRequired: 'الوكالة مطلوبة',
    customerRequired: 'العميل مطلوب',
    carRequired: 'السيارة مطلوبة',
    datesRequired: 'تواريخ البداية والنهاية مطلوبة',
    startTime: 'وقت البداية',
    endTime: 'وقت النهاية',
    calculatePrice: 'حساب السعر',
    bookingCreated: 'تم إنشاء الحجز بنجاح',
    createBookingError: 'فشل في إنشاء الحجز',
    totalPrice: 'السعر الإجمالي',
    createNewCustomer: 'إنشاء عميل جديد',
    customerName: 'اسم العميل',
    customerPhone: 'هاتف العميل',
    noAgenciesFound: 'لم يتم العثور على وكالات',
    noCustomersFound: 'لم يتم العثور على عملاء',
    noCarsFound: 'لم يتم العثور على سيارات للوكالة المحددة',
    pricePerDay: 'السعر في اليوم'
  },
  
  users: {
    title: 'إدارة المستخدمين',
    management: 'إدارة المستخدمين',
    subtitle: 'إدارة ومراقبة جميع مستخدمي المنصة'
  },

  clients: {
    title: 'العملاء',
    subtitle: 'إدارة ومراقبة جميع العملاء',
    totalClients: 'إجمالي العملاء',
    activeClients: 'العملاء النشطون',
    verifiedClients: 'العملاء المتحققون',
    newThisMonth: 'جديد هذا الشهر',
    errorTitle: 'فشل في تحميل العملاء',
    retry: 'إعادة المحاولة',
    
    // Table columns
    clientName: 'اسم العميل',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    bookings: 'الحجوزات',
    totalSpent: 'إجمالي المصروف',
    lastBooking: 'آخر حجز',
    status: 'الحالة',
    verification: 'التحقق',
    joined: 'انضم',
    role: 'الدور',
    
    // Filters
    
    // Status labels
    active: 'نشط',
    inactive: 'غير نشط',
    suspended: 'معلق',
    
    // Verification status
    verified: 'متحقق',
    unverified: 'غير متحقق',
    pending: 'معلق',
    
    // Actions
    view: 'عرض',
    edit: 'تعديل',
    delete: 'حذف',
    actions: 'الإجراءات',
    
    // Dialog
    clientDetails: 'تفاصيل العميل',
    editClient: 'تعديل العميل',
    
    // Messages
    fetchError: 'فشل في تحميل العملاء',
    deleteError: 'فشل في حذف العميل',
    deleteSuccess: 'تم حذف العميل بنجاح',
    updateSuccess: 'تم تحديث العميل بنجاح',
    updateError: 'فشل في تحديث العميل',
    deleteFailed: 'فشل في حذف العميل',
    permissionDenied: 'تم رفض الإذن. قد لا تملك الصلاحيات اللازمة لحذف هذا العميل.',
    
    // Placeholders
    client: 'العميل',
    noName: 'لا يوجد اسم',
    noPhone: 'لا يوجد هاتف',
    never: 'أبداً',
    
    // Common placeholders
    min: 'الحد الأدنى',
    max: 'الحد الأقصى'
  },
  
  settings: {
    title: 'إعدادات الإدارة',
    subtitle: 'تكوين إعدادات وتفضيلات المنصة',
    general: 'عام',
    platform: 'المنصة',
    security: 'الأمان',
    notifications: 'الإشعارات',
    
    // General Settings
    platformName: 'اسم المنصة',
    platformDescription: 'وصف المنصة',
    defaultLanguage: 'اللغة الافتراضية',
    timezone: 'المنطقة الزمنية',
    currency: 'العملة الافتراضية',
    
    // Platform Settings
    maintenanceMode: 'وضع الصيانة',
    maintenanceModeDesc: 'تفعيل وضع الصيانة لمنع وصول المستخدمين',
    userRegistration: 'تسجيل المستخدمين',
    userRegistrationDesc: 'السماح للمستخدمين الجدد بالتسجيل في المنصة',
    agencyRegistration: 'تسجيل الوكالات',
    agencyRegistrationDesc: 'السماح للوكالات الجديدة بالتسجيل في المنصة',
    
    // Security Settings
    passwordPolicy: 'سياسة كلمة المرور',
    passwordPolicyDesc: 'تكوين متطلبات كلمة المرور',
    twoFactorAuth: 'المصادقة الثنائية',
    twoFactorAuthDesc: 'طلب المصادقة الثنائية لحسابات الإدارة',
    emailVerification: 'التحقق من البريد الإلكتروني',
    emailVerificationDesc: 'طلب التحقق من البريد الإلكتروني للتسجيلات الجديدة',
    sessionTimeout: 'انتهاء صلاحية الجلسة',
    sessionTimeoutDesc: 'تسجيل خروج المستخدمين غير النشطين تلقائياً',
    
    // Notification Settings
    emailNotifications: 'إشعارات البريد الإلكتروني',
    emailNotificationsDesc: 'إرسال إشعارات البريد الإلكتروني للأحداث المهمة',
    smsNotifications: 'إشعارات الرسائل النصية',
    smsNotificationsDesc: 'إرسال إشعارات الرسائل النصية للتنبيهات الحرجة',
    
    // Watermark Settings
    watermark: 'علامة مائية للصور',
    watermarkEnabled: 'تفعيل العلامة المائية',
    watermarkEnabledDesc: 'إضافة علامة مائية على جميع صور السيارات',
    watermarkImage: 'صورة العلامة المائية',
    watermarkChangeImage: 'تغيير الصورة',
    watermarkUploadImage: 'رفع الصورة',
    watermarkUpload: 'رفع',
    watermarkUploading: 'جاري الرفع...',
    watermarkImageUploaded: 'تم رفع صورة العلامة المائية بنجاح',
    watermarkImageLoadError: 'الصورة غير موجودة',
    watermarkRemove: 'إزالة',
    watermarkImageHelp: 'موصى به: PNG بخلفية شفافة، الحد الأقصى 5MB. ستحافظ العلامة المائية على نسبة العرض إلى الارتفاع.',
    watermarkCurrentImage: 'صورة العلامة المائية الحالية نشطة',
    watermarkOpacity: 'الشفافية',
    watermarkOpacityDesc: 'شفافية العلامة المائية (0-100%)',
    watermarkSize: 'الحجم',
    watermarkSizeDesc: 'حجم العلامة المائية كنسبة مئوية من عرض الصورة (5-50%)',
    watermarkPreview: 'معاينة العلامة المائية',
    watermarkPreviewDesc: 'معاينة على صورة سيارة حقيقية من قاعدة البيانات',
    watermarkShowPreview: 'عرض المعاينة',
    watermarkLoadingCar: 'جاري تحميل صورة السيارة...',
    watermarkGenerating: 'جاري إنشاء المعاينة...',
    watermarkPreviewError: 'فشل تحميل صورة المعاينة',
    watermarkPreviewErrorHelp: 'ستستخدم المعاينة العلامة المائية من جانب العميل كحل بديل.',
    watermarkPreviewFallback: 'استخدام الصورة الأصلية - معاينة العلامة المائية غير متاحة',
    watermarkDisabled: 'العلامة المائية معطلة. قم بتفعيلها لرؤية المعاينة.',
    watermarkPreviewNote: 'تستخدم هذه المعاينة صورة سيارة حقيقية من قاعدة البيانات الخاصة بك وتظهر بالضبط كيف ستظهر العلامة المائية على موقعك.',
    
    // Actions
    save: 'حفظ الإعدادات',
    saving: 'جاري الحفظ...',
    saved: 'تم حفظ الإعدادات بنجاح',
    error: 'خطأ في حفظ الإعدادات',
    
    // Pagination
    showing: 'عرض',
    to: 'إلى',
    of: 'من',
    results: 'نتيجة',
    perPage: 'في الصفحة'
  },

  // Brands & Models Management
  brandsModels: {
    title: 'إدارة العلامات التجارية والموديلات',
    subtitle: 'إدارة علامات وموديلات السيارات التجارية',
    brands: 'العلامات التجارية',
    models: 'الموديلات',
    totalBrands: 'إجمالي العلامات التجارية',
    totalModels: 'إجمالي الموديلات',
    
    // Brand management
    brandName: 'اسم العلامة التجارية',
    logoUrl: 'رابط الشعار',
    modelCount: 'عدد الموديلات',
    createdAt: 'تاريخ الإنشاء',
    addBrand: 'إضافة علامة تجارية',
    editBrand: 'تعديل العلامة التجارية',
    deleteBrand: 'حذف العلامة التجارية',
    addBrandDescription: 'إضافة علامة تجارية جديدة للسيارات إلى النظام',
    editBrandDescription: 'تعديل العلامة التجارية المحددة',
    deleteBrandConfirm: 'هل أنت متأكد من حذف العلامة التجارية "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',
    brandNamePlaceholder: 'أدخل اسم العلامة التجارية (مثل: تويوتا)',
    logoUrlPlaceholder: 'أدخل رابط الشعار (اختياري)',
    logoUrlHelp: 'أدخل رابط صحيح لصورة شعار العلامة التجارية',
    searchBrands: 'البحث في العلامات التجارية...',
    noBrands: 'لم يتم العثور على علامات تجارية',
    
    // Model management
    modelName: 'اسم الموديل',
    brand: 'العلامة التجارية',
    yearRange: 'نطاق السنوات',
    yearStart: 'سنة البداية',
    yearEnd: 'سنة النهاية',
    addModel: 'إضافة موديل',
    editModel: 'تعديل الموديل',
    deleteModel: 'حذف الموديل',
    addModelDescription: 'إضافة موديل سيارة جديد إلى النظام',
    editModelDescription: 'تعديل الموديل المحدد',
    deleteModelConfirm: 'هل أنت متأكد من حذف الموديل "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',
    modelNamePlaceholder: 'أدخل اسم الموديل (مثل: كامري)',
    selectBrand: 'اختر علامة تجارية',
    filterByBrand: 'تصفية حسب العلامة التجارية',
    allBrands: 'جميع العلامات التجارية',
    searchModels: 'البحث في الموديلات...',
    noModels: 'لم يتم العثور على موديلات',
    yearRangeHelp: 'اتركه فارغاً إذا كان الموديل لا يزال في الإنتاج',
    preSelectedBrand: 'العلامة التجارية المحددة مسبقاً',
    
    // Models Dialog
    modelsDialog: {
      title: '{{brandName}} - الموديلات',
      description: 'إدارة موديلات {{brandName}}',
      addModel: 'إضافة موديل',
      noModels: 'لا توجد موديلات لهذه العلامة التجارية',
      modelsList: 'قائمة الموديلات'
    },
    modelsCount: '{{count}} موديل',
    viewModels: 'عرض الموديلات',
    
    // Success messages
    success: {
      brandCreated: 'تم إنشاء العلامة التجارية بنجاح',
      brandUpdated: 'تم تحديث العلامة التجارية بنجاح',
      brandDeleted: 'تم حذف العلامة التجارية بنجاح',
      modelCreated: 'تم إنشاء الموديل بنجاح',
      modelUpdated: 'تم تحديث الموديل بنجاح',
      modelDeleted: 'تم حذف الموديل بنجاح'
    },
    
    // Error messages
    errors: {
      fetchBrands: 'فشل في تحميل العلامات التجارية',
      fetchModels: 'فشل في تحميل الموديلات',
      createBrand: 'فشل في إنشاء العلامة التجارية',
      updateBrand: 'فشل في تحديث العلامة التجارية',
      deleteBrand: 'فشل في حذف العلامة التجارية',
      createModel: 'فشل في إنشاء الموديل',
      updateModel: 'فشل في تحديث الموديل',
      deleteModel: 'فشل في حذف الموديل',
      saveBrand: 'فشل في حفظ العلامة التجارية',
      saveModel: 'فشل في حفظ الموديل',
      brandHasModels: 'لا يمكن حذف علامة تجارية لها موديلات مرتبطة'
    },
    
    // Validation messages
    validation: {
      nameRequired: 'اسم العلامة التجارية مطلوب',
      modelNameRequired: 'اسم الموديل مطلوب',
      brandRequired: 'اختيار العلامة التجارية مطلوب',
      invalidUrl: 'يرجى إدخال رابط صحيح',
      yearEndMustBeAfterStart: 'سنة النهاية يجب أن تكون بعد سنة البداية',
      invalidYearStart: 'سنة البداية غير صحيحة',
      invalidYearEnd: 'سنة النهاية غير صحيحة'
    }
  },

  // WhatsApp Action Settings
  whatsapp: {
    actions: {
      title: 'إجراءات الإشعارات',
      description: 'تحكم في الإجراءات التي تطلق إشعارات واتساب واختر القوالب لكل إجراء',
      new_booking: {
        name: 'حجز جديد تم استلامه',
        description: 'إشعار صاحب الوكالة عند إنشاء حجز جديد'
      },
      booking_confirmed: {
        name: 'تم تأكيد الحجز',
        description: 'إشعار صاحب الوكالة عند تأكيد الحجز'
      },
      booking_cancelled: {
        name: 'تم إلغاء الحجز',
        description: 'إشعار صاحب الوكالة عند إلغاء الحجز'
      },
      client_registered: {
        name: 'عميل جديد مسجل',
        description: 'إشعار صاحب الوكالة عند تسجيل عميل جديد'
      },
      vehicle_added: {
        name: 'تم إضافة مركبة',
        description: 'إشعار صاحب الوكالة عند إضافة مركبة للأسطول'
      },
      vehicle_removed: {
        name: 'تم حذف مركبة',
        description: 'إشعار صاحب الوكالة عند حذف مركبة من الأسطول'
      },
      payment_reminder: {
        name: 'تذكير بالدفع',
        description: 'إرسال تذكيرات الدفع للعملاء'
      },
      selectTemplate: 'اختر قالب',
      saveActions: 'حفظ الإجراءات',
      saving: 'جاري الحفظ...',
      actionsSaved: 'تم حفظ إعدادات الإجراءات بنجاح',
      actionsSaveError: 'فشل في حفظ إعدادات الإجراءات'
    }
  }
}; 